import { render } from "./CreateProviderModal.vue?vue&type=template&id=3b25550e"
import script from "./CreateProviderModal.vue?vue&type=script&lang=js"
export * from "./CreateProviderModal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "3b25550e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b25550e', script)) {
    api.reload('3b25550e', script)
  }
  
  module.hot.accept("./CreateProviderModal.vue?vue&type=template&id=3b25550e", () => {
    api.rerender('3b25550e', render)
  })

}

script.__file = "resources/js/Pages/User/Partials/CreateProviderModal.vue"

export default script